import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SignupData, SignupStep, SignupContextType } from '../types';

// Create the context
const SignupContext = createContext<SignupContextType | undefined>(undefined);

// Provider component
interface SignupProviderProps {
  children: ReactNode;
}

export const SignupProvider: React.FC<SignupProviderProps> = ({ children }) => {
  const [signupData, setSignupDataState] = useState<SignupData | null>(null);
  const [currentStep, setCurrentStep] = useState<SignupStep>(SignupStep.LANDING);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const setSignupData = (data: SignupData) => {
    setSignupDataState(data);
    // Clear any existing errors when new data is set
    setError(null);
  };

  const value: SignupContextType = {
    signupData,
    setSignupData,
    currentStep,
    setCurrentStep,
    isLoading,
    setIsLoading,
    error,
    setError,
  };

  return (
    <SignupContext.Provider value={value}>
      {children}
    </SignupContext.Provider>
  );
};

// Custom hook to use the signup context
export const useSignup = (): SignupContextType => {
  const context = useContext(SignupContext);
  
  if (context === undefined) {
    throw new Error('useSignup must be used within a SignupProvider');
  }
  
  return context;
};
